export const LIST_BRANCH_TEAM_REQUEST = 'LIST_BRANCH_TEAM_REQUEST'
export const LIST_BRANCH_TEAM_SUCCESS = 'LIST_BRANCH_TEAM_SUCCESS'
export const LIST_BRANCH_TEAM_FAIL = 'LIST_BRANCH_TEAM_FAIL'
export const LIST_BRANCH_TEAM_RESET = 'LIST_BRANCH_TEAM_RESET'

export const LIST_BRANCH_TEAM_SUMMARY_REQUEST = 'LIST_BRANCH_TEAM_SUMMARY_REQUEST'
export const LIST_BRANCH_TEAM_SUMMARY_SUCCESS = 'LIST_BRANCH_TEAM_SUMMARY_SUCCESS'
export const LIST_BRANCH_TEAM_SUMMARY_FAIL = 'LIST_BRANCH_TEAM_SUMMARY_FAIL'
export const LIST_BRANCH_TEAM_SUMMARY_RESET = 'LIST_BRANCH_TEAM_SUMMARY_RESET'

export const CREATE_BRANCH_TEAM_REQUEST = 'CREATE_BRANCH_TEAM_REQUEST'
export const CREATE_BRANCH_TEAM_SUCCESS = 'CREATE_BRANCH_TEAM_SUCCESS'
export const CREATE_BRANCH_TEAM_FAIL = 'CREATE_BRANCH_TEAM_FAIL'

export const DETAIL_BRANCH_TEAM_REQUEST = 'DETAIL_BRANCH_TEAM_REQUEST'
export const DETAIL_BRANCH_TEAM_SUCCESS = 'DETAIL_BRANCH_TEAM_SUCCESS'
export const DETAIL_BRANCH_TEAM_FAIL = 'DETAIL_BRANCH_TEAM_FAIL'

export const UPDATE_BRANCH_TEAM_REQUEST = 'UPDATE_BRANCH_TEAM_REQUEST'
export const UPDATE_BRANCH_TEAM_SUCCESS = 'UPDATE_BRANCH_TEAM_SUCCESS'
export const UPDATE_BRANCH_TEAM_FAIL = 'UPDATE_BRANCH_TEAM_FAIL'

export const DELETE_BRANCH_TEAM_REQUEST = 'DELETE_BRANCH_TEAM_REQUEST'
export const DELETE_BRANCH_TEAM_SUCCESS = 'DELETE_BRANCH_TEAM_SUCCESS'
export const DELETE_BRANCH_TEAM_FAIL = 'DELETE_BRANCH_TEAM_FAIL'

export const RESET_BRANCH_TEAM = 'RESET_BRANCH_TEAM'
